/*
 * @Author: fengqianhui
 * @Date: 2024-01-11 09:33:51
 * @LastEditors: 18518155760 111m
 * @LastEditTime: 2024-01-17 11:17:53
 * @FilePath: \landingpage\src\views\build\hooks\useResult.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */

export function buildResult() {
  const isMobileDevice = (): boolean => {
    const ua = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  };
  const isMobile = ref(isMobileDevice());
  if (isMobileDevice()) {
    document.body.classList.add('mobile-viewport');
  } else {
    document.body.classList.remove('mobile-viewport');
  }
  return { isMobile };
}
